import React, { Component } from 'react';
/* eslint-disable */
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import DownIcon from 'mdi-react/ChevronDownIcon';
import {
	DropdownItem,
	DropdownToggle,
	DropdownMenu,
	UncontrolledDropdown,
} from 'reactstrap';
import TopbarNavLink from './TopbarNavLink';
import TopbarNavCategory from './TopbarNavCategory';
const initialstate = {
	showrecsnow: localStorage.viewrecruiter,
};
class TopbarNavCompany extends Component {
	constructor(props) {
		super(props);
		localStorage.viewrecruiter;
	}
	state = { ...initialstate };
	handleCkey = () => {
		localStorage.setItem('viewrecruiter', '');
		location.assign('/dashboard');
	};
	render() {
		return (
			<nav className="topbar__nav">
				<UncontrolledDropdown className="topbar__nav-dropdown">
					<DropdownToggle className="topbar__nav-dropdown-toggle">
						Screening
						<DownIcon />
					</DropdownToggle>

					<DropdownMenu className="topbar__nav-dropdown-menu dropdown__menu">
						{/* <DropdownItem>
							<TopbarNavLink title="Phone Screen" route="/faqtechview" />
						</DropdownItem>
						<DropdownItem>
							<TopbarNavLink title="Add Test" route="/addtest" />
						</DropdownItem>
						<DropdownItem>
							<TopbarNavLink title="Saved Tests" route="/savetest" />
						</DropdownItem>
						<DropdownItem>
							<TopbarNavLink title="Sent Tests" route="/senttests" />
						</DropdownItem>
						<DropdownItem>
							<TopbarNavLink title="Completed Tests" route="/comtest" />
						</DropdownItem> */}
						<DropdownItem>
							<TopbarNavLink title="Phone Screen" route="/faqtechview" />
						</DropdownItem>
						<DropdownItem>
							<TopbarNavCategory title="Tech Tests" icon="smart-phone">
								<TopbarNavLink title="Add Test" route="/addtest" />
								<TopbarNavLink title="Saved Tests" route="/savetest" />
								<TopbarNavLink title="Sent Tests" route="/senttests" />
								<TopbarNavLink title="Completed Tests" route="/comtest" />
							</TopbarNavCategory>
						</DropdownItem>
						<DropdownItem>
							<TopbarNavCategory title="Custom Tests" icon="smart-phone">
								<TopbarNavLink title="Add Custom Test" route="/addcustomtest" />
								<TopbarNavLink title="UnSaved Test List" route="/mycustoms" />
								<TopbarNavLink
									title="Saved Test List"
									route="/customsavedtest"
								/>
								<TopbarNavLink title="Sent Test List" route="/customsenttest" />
								<TopbarNavLink
									title="Completed Custom Tests"
									route="/cuscomtest"
								/>
							</TopbarNavCategory>
						</DropdownItem>
					</DropdownMenu>
				</UncontrolledDropdown>
			</nav>
		);
	}
}

export default TopbarNavCompany;
